import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { IntegrationThemes, PaymentMethodInput } from '@cashier/cashier-model';
import { AmountConverter } from '@cashier/cashier-shared';
import { PlainHtmlContainer } from '@cashier/cashier-ui';

import { InformationBlockContentWrapper } from '../../informationBlockContent';

interface InformationBlockProps {
  amount: string;
  currency: string;
  fields: PaymentMethodInput[];
  onButtonClick: () => void;
  paymentMethodMessage: string | null;
}

export const InformationBlock = ({
  amount,
  currency,
  fields,
  onButtonClick,
  paymentMethodMessage,
}: InformationBlockProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="final-screen final-screen--visible">
      <p className="final-screen__heading">{t('completePayment.heading')}</p>
      <h3 className="final-screen__sum">
        {AmountConverter.exponentialNotationToNumber(String(AmountConverter.toDelimitedNumber(amount || 0)))}{' '}
        {currency}
      </h3>
      <p className="final-screen__paragraph">{t('completePayment.message')}</p>
      {paymentMethodMessage && <PlainHtmlContainer content={paymentMethodMessage} />}
      {fields.map((field) => (
        <InformationBlockContentWrapper
          key={field.name}
          field={field}
          theme={IntegrationThemes.Default}
        />
      ))}

      <div className="final-screen__divider">{t('completePayment.or')}</div>
      <button
        className="final-screen__button"
        type="button"
        onClick={onButtonClick}
      >
        {t('makeNewTransaction.button')}
      </button>
    </div>
  );
};
